import { createRoot } from "react-dom/client";
import "./index.css";
import { redirectWwwToApex } from "./lib/canonicalRedirect";

const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");
const pathname = basePath && window.location.pathname.startsWith(basePath)
  ? window.location.pathname.slice(basePath.length) || "/"
  : window.location.pathname;

if (!redirectWwwToApex()) {
  const root = createRoot(document.getElementById("root")!);

  if (pathname === "/") {
    const { default: Landing } = await import("./pages/Landing");
    root.render(<Landing />);
  } else {
    const { default: App } = await import("./App");
    root.render(<App />);
  }
}
